//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, AbsOverflow } from "../../styles/theme";
import ScrollNotifier from "../ScrollNotifier";
import MenuWrap from "../MenuWrap";

const Screen = styled.section`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: none;
  justify-content: center;
  align-items: center;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  ${mqMin(theme.desktop)} {
    margin-left: auto;
    margin-right: auto;
    max-width: ${theme.maxWidth3};
  }
`;
const Text = styled.h2`
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
  font-size: ${theme.h1};
  line-height: ${theme.lineHeight3};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.super};
    line-height: ${theme.lineHeight1};
  }
`;
const Heading = styled.h3`
  font-size: ${theme.h3};
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.normal};
  line-height: ${theme.lineHeight1};
  margin-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h2};
  }
`;

const Panda = ({ page, heading = "What's a PandaGoat?", open = false }) => {
  return (
    <MenuWrap y={-100} open={"PANDA"}>
      <Screen>
        <div>
          <Heading>{heading}</Heading>
          <Text>Honestly, we have no idea.</Text>
        </div>
      </Screen>
    </MenuWrap>
  );
};

export default Panda;



// WEBPACK FOOTER //
// ./src/components/Panda/index.js